import { isDevMode } from '@angular/core';

//For local development
// export const baseServer =
//   isDevMode() == true
//     ? 'https://localhost:44363/graphql/'
//     : 'https://evoweb.gfk.com/streamingDashboardNG/api/';
// export const baseServerRoot =
//   isDevMode() == true
//     ? 'https://localhost:44363/'
//     : 'https://evoweb.gfk.com/streamingDashboardNG/';
// export const baseServerExport =
//   isDevMode() == true
//     ? 'https://localhost:44363/'
//     : 'https://evoweb.gfk.com/streamingDashboardNG/';

// For production
// export const baseServer = 'api';
// export const baseServerRoot = 'api';
// export const baseServerExport = 'exp';

// For test system
// export const baseServer = 'https://dcew1184test001.gfk.com:44363/graphql/';
// export const baseServerRoot = 'https://dcew1184test001.gfk.com:44363/';
// export const baseServerExport = 'https://dcew1184test001.gfk.com:44363/';

// For LT
export const baseServer = 'api';
export const baseServerRoot = 'api';
export const baseServerExport = 'exp';
